import { TIPTAP_AUDIO_TYPE } from "./../../ricos-content";
import { createRicosNodeExtension } from "./../../plugin-commons";
import { Audio as Component } from "./component";
const name = TIPTAP_AUDIO_TYPE;
const tiptapExtensions = [
  createRicosNodeExtension({
    groups: ["overlay", "draggable", "not-overtypable"],
    type: "react-node",
    name,
    reconfigure: (config, _extensions, _props, settings) => ({
      ...config,
      addOptions: () => settings
    }),
    Component,
    createExtensionConfig() {
      return {
        name: this.name,
        group: "block layoutCellContent collapsibleListItemBodyContent tableCellContent",
        selectable: true,
        draggable: true,
        addAttributes: () => ({
          containerData: null,
          audio: null,
          disableDownload: null,
          coverImage: null,
          name: null,
          authorName: null,
          html: null,
          loading: {
            default: false
          },
          error: null
        }),
        addCommands() {
          return {};
        }
      };
    }
  })
];
export {
  tiptapExtensions
};
//# sourceMappingURL=tiptap.js.map
